import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { VisitContents } from '@mummssoftware/common-ui';
import { Button } from '@material-ui/core';
import styled from 'styled-components';
import { GlobalContext } from '@mummssoftware/global-context';
import Checkbox from '@material-ui/core/Checkbox';
import {
  formatDateTimeMMDDpm,
  formatUTCLocalMMDDYY,
} from '@mummssoftware/utils/formatters';
import { getVisitByPersonAndVisitId } from '@mummssoftware/utils/pimReader';
import moment from 'moment';
import Manifest from '@mummssoftware/manifest';
import { VisitContext } from '../Context/contexts/VisitContext';
import { Context } from '../../context';
import { IPU, SET_VISIT_TITLE, SHOW_VISIT_LOADER } from '../Context/constants';
import { HCPCSContext } from '../Context/contexts/HCPCSContext';

import { VisitButtonDiv, VisitSubmitDiv } from '../../components';
import defaults from '../../translations/en.json';

const HeaderText = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 6px;
`;

export const PriorVisit = () => {
  const { patient, keycloak, agency, currentUser } = useContext(Context);
  const { siteTimezone } = currentUser;
  const {
    IPUVisit,
    dispatchVisit,
    savedVisit,
    closeDocumentingVisit,
    closingPriorVisit,
  } = useContext(VisitContext);
  const { dispatchHCPCS } = useContext(HCPCSContext);
  const { appVisit, widgetsOpen } = useContext(GlobalContext);

  const [priorVisitDto, setPriorVisitDto] = useState<any>(null);

  const getDocumentTitleDate = () => {
    if (savedVisit) {
      const text = IPUVisit ? IPU : savedVisit.levelofcareDisplayValue;
      return `${text} on ${formatUTCLocalMMDDYY(savedVisit.startDate)}`;
    }
    if (priorVisitDto) {
      const text = IPUVisit ? IPU : priorVisitDto.levelofcare;
      const datetime =
        siteTimezone &&
        formatDateTimeMMDDpm(
          moment.utc(priorVisitDto.effectivedatetime).tz(siteTimezone).toDate(),
        );
      return `${text} on ${datetime}`;
    }
    return '';
  };

  const getAppVisitText = () => {
    if (priorVisitDto) {
      const text = IPUVisit ? IPU : priorVisitDto.levelofcare;
      const datetime =
        siteTimezone &&
        formatDateTimeMMDDpm(
          moment.utc(priorVisitDto.effectivedatetime).tz(siteTimezone).toDate(),
        );
      return `${text} on ${datetime}`;
    }
    return defaults.loading;
  };

  const fetchPriorDetails = async () => {
    const priorDTO = appVisit;
    try {
      if (priorDTO) {
        const details = await getVisitByPersonAndVisitId(
          currentUser.personNumber || '',
          `${priorDTO.id}`,
          agency,
          keycloak,
        );
        setPriorVisitDto({
          ...details[0],
        });
      }
    } finally {
      dispatchHCPCS({
        type: SHOW_VISIT_LOADER,
        payload: false,
      });
    }
  };

  useEffect(() => {
    fetchPriorDetails();
    const title = (
      <FormattedMessage
        {...defaults.documentingOnVisit}
        values={{
          date: getDocumentTitleDate(),
        }}
      />
    );
    dispatchVisit({
      type: SET_VISIT_TITLE,
      payload: title,
    });
  }, [appVisit, savedVisit?.id]);

  useEffect(() => {
    if (widgetsOpen.length === 0) {
      fetchPriorDetails();
    }
  }, [widgetsOpen]);

  const handleClose = () => {
    closeDocumentingVisit();
  };

  return (
    <div style={{ minWidth: '30vw' }}>
      {appVisit ? (
        <>
          <HeaderText id="start-visit">
            <div>{getAppVisitText()}</div>
          </HeaderText>
          <VisitContents
            dto={priorVisitDto && priorVisitDto}
            editing={false}
            editF2F={
              priorVisitDto?.facetofacevisit &&
              (() => <Checkbox checked onChange={() => null} disabled />)
            }
            agency={agency}
            keycloak={keycloak}
            patientNumber={patient?.patientNumber}
            ManifestWidget={Manifest}
          />
        </>
      ) : (
        <>{defaults.loading}</>
      )}
      <VisitSubmitDiv>
        <VisitButtonDiv>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={handleClose}
            disabled={closingPriorVisit}
          >
            {defaults.close}
          </Button>
        </VisitButtonDiv>
      </VisitSubmitDiv>
    </div>
  );
};
